export default "__VITE_ASSET__BBzWbpbk__"